import { PatternFormat, PatternFormatProps } from 'react-number-format';

import { Input, InputProps } from './input.component';

export type MaskedInputProps = Omit<PatternFormatProps<InputProps>, 'customInput'>;

export const MaskedInput = ({ mask = '_', inputMode = 'numeric', ...rest }: MaskedInputProps) => {
  return <PatternFormat customInput={Input} mask={mask} inputMode={inputMode} {...rest} />;
};
